// Status do link de pagamento ao cliente final (Fase 1).
export const PAYMENT_LINK_STATUS = {
	CRIADO: 'criado',
	ENVIADO: 'enviado',
	ABERTO: 'aberto',
	PAGO: 'pago',
	EXPIRADO: 'expirado',
	CANCELADO: 'cancelado'
};

export const PAYMENT_LINK_STATUS_OPTIONS = [
	{ value: PAYMENT_LINK_STATUS.CRIADO, label: 'Criado', severity: 'secondary' },
	{ value: PAYMENT_LINK_STATUS.ENVIADO, label: 'Enviado', severity: 'info' },
	{ value: PAYMENT_LINK_STATUS.ABERTO, label: 'Aberto', severity: 'warning' },
	{ value: PAYMENT_LINK_STATUS.PAGO, label: 'Pago', severity: 'success' },
	{ value: PAYMENT_LINK_STATUS.EXPIRADO, label: 'Expirado', severity: 'danger' },
	{ value: PAYMENT_LINK_STATUS.CANCELADO, label: 'Cancelado', severity: 'danger' }
];

export const paymentLinkStatusLabel = (value) =>
	(PAYMENT_LINK_STATUS_OPTIONS.find((o) => o.value === value) || {}).label || value;

export const paymentLinkStatusSeverity = (value) =>
	(PAYMENT_LINK_STATUS_OPTIONS.find((o) => o.value === value) || {}).severity || 'secondary';

/**
 * Urgência em relação ao prazo de pagamento (cancellationDeadline).
 * Alinhado com o owner: ≤3 dias = aviso (amarelo), ≤24h = urgente (vermelho),
 * vencido = expirado/bloqueado.
 * @returns {{ level: 'normal'|'aviso'|'urgente'|'vencido', diasRestantes: number|null }}
 */
export const getDeadlineUrgency = (deadline, now = new Date()) => {
	if (!deadline) return { level: 'normal', diasRestantes: null };
	const dl = new Date(deadline);
	if (Number.isNaN(dl.getTime())) return { level: 'normal', diasRestantes: null };
	const ms = dl.getTime() - now.getTime();
	const horas = ms / (1000 * 60 * 60);
	const dias = Math.ceil(horas / 24);
	if (ms <= 0) return { level: 'vencido', diasRestantes: 0 };
	if (horas <= 24) return { level: 'urgente', diasRestantes: dias };
	if (horas <= 72) return { level: 'aviso', diasRestantes: dias };
	return { level: 'normal', diasRestantes: dias };
};
